import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './app';
import AppProvider from './app-provider';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://28b9ad40b9e2cbe78353923013dd1c15@o4509131237359616.ingest.us.sentry.io/4509131238277120"
});

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <AppProvider>
        <Router>
          <App />
        </Router>
      </AppProvider>
    </React.StrictMode>
  );
}